import type { UserTaskCoverage } from "@/types/userTasks.ts";

const SOURCE_LABEL: Record<string, string> = { mail: "Mail", granola: "Granola notes" };

/** Cased to lead a line of its own, since each source is drawn as a row. */
const COVERAGE_STATUS: Record<string, string> = {
  "not-ready": "Notes not ready yet",
  importing: "Still importing",
  "not-connected": "Not connected",
  failed: "Could not be read",
};

/** One source okthx reads for new tasks: its name, and how its last read went. */
type CoverageRow = { label: string; detail: string };

/**
 * Which sources okthx last read for new tasks, and when — one row per
 * source, so a list that missed a source says so instead of looking complete.
 */
export function coverageRows(coverage: readonly UserTaskCoverage[]): CoverageRow[] {
  return coverage.map((entry) => {
    const label = SOURCE_LABEL[entry.source] ?? entry.source;
    const time = new Date(entry.atMs).toLocaleTimeString(undefined, {
      hour: "numeric",
      minute: "2-digit",
    });
    const problem = COVERAGE_STATUS[entry.status];
    return { label, detail: problem ? `${problem} (${time})` : `Read ${time}` };
  });
}
